import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { environment } from './../../../../../environments/environment';

@Injectable()
export class SiteEditService {

  private urlPrefix: string = environment.appUrl;

  constructor(
    private http: HttpClient
  ) { }

  edit(id, post): Observable<any> {
    const url = this.urlPrefix + 'sites/' + id;
    return this.http
      .put(url, {
        customerId: post.customerId.value,
        location: post.location.value,
        locationShort: post.locationShort.value,
        endUser: post.endUser.value,
        contactNameOne: post.contactNameOne.value,
        contactNumberOne: post.contactNumberOne.value,
        contactEmailOne: post.contactEmailOne.value,
        contactNameTwo: post.contactNameTwo.value,
        contactNumberTwo: post.contactNumberTwo.value,
        contactEmailTwo: post.contactEmailTwo.value,
        remarks: post.remarks.value
      }, { observe: 'response' })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/site/site-edit/site-edit.service.ts